// extracted by mini-css-extract-plugin
module.exports = {"dot":"Carousel_dot__3W8l5","activeDot":"Carousel_activeDot__1syHH"};